import { AddressSchema } from '@/types/common-types';
import { z } from 'zod';
import { SelectedIntegration } from './SelectIntegrationType';
import { PropsWithChildren } from 'react';
import { FormProvider, useForm, useFormContext } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';

type FormSchema = z.infer<typeof FormSchema>;
const FormSchema = z.object({
  deviceName: z.string().min(1, 'Device name is required'),
  serialNumber: z.string().optional(),
  description: z.string().optional(),
  routeNamespaceId: z.string().optional(),
  address: AddressSchema.optional(),
  deviceType: z
    .any()
    .refine(
      (x): x is SelectedIntegration => 
        typeof x === 'object' && x !== null && ('integration' in x || 'externalConnection' in x),
      {
        message: 'Please select a device type'
      }
    ),
  integrationVariables: z.record(z.string(), z.string()),
  monitoredDevices: z.record(z.boolean()),
});

export const AddDeviceFormProvider = (props: PropsWithChildren) => {
  const form = useForm<FormSchema>({
    defaultValues: {
      address: {},
      description: "",
      deviceName: '',
      serialNumber: '',
      routeNamespaceId: '',
      deviceType: undefined,
      integrationVariables: {},
      monitoredDevices: {},
    },
    mode: "onBlur",
    resolver: zodResolver(FormSchema),
  });

  return <FormProvider {...form}>{props.children}</FormProvider>;
};

export const useAddDeviceFormCtx = () => useFormContext<FormSchema>();
